import { h, Component } from 'preact'
import linkState from 'linkstate'

import Input from 'app/components/Input'
import Form from 'app/components/Form'
import Button from 'app/components/Button'
import { connect } from 'app/store'
import Alert from 'react-s-alert'

class SignUp extends Component {
  state = {
    form: {
      email: '',
      password: '',
      password2: '',
      username: '',
    },
    formSubmitted: false,
    countdown: 5,
  }

  onFormSubmit = async () => {
    const { email, password, password2, username } = this.state.form

    if (password !== password2) {
      return Alert.error('Passwords are different')
    }

    // Send to API
    await this.props.register({ email, password, username })

    // Replace button with message
    this.setState({ formSubmitted: true })

    // Redirect in 5 seconds
    setTimeout(() => {
      window.location.replace('https://gumroad.com/l/manter')
    }, 5000)

    // Decrement countdown
    const counter = setInterval(() => {
      const { countdown } = this.state

      if (countdown === 0) return clearInterval(counter)

      this.setState({ countdown: countdown - 1 })
    }, 1000)
  }

  render(_props, state) {
    const { email, password, password2, username } = state.form
    const { formSubmitted, countdown } = state

    return (
      <div class="row mt-5">
        <div class="col-lg-4 col-sm-12 col-xs-12 mx-auto">
          <h3 class="mb-5 text-center">Sign Up</h3>
          <Form onSubmit={() => this.onFormSubmit()}>
            <Input
              label="Username"
              type="text"
              value={username}
              class="mb-3 w-100"
              onInput={linkState(this, 'form.username')}
              required
            />
            <Input
              label="Email"
              value={email}
              class="mb-3 w-100"
              onInput={linkState(this, 'form.email')}
              required
            />
            <Input
              label="Password"
              type="password"
              value={password}
              class="mb-3 w-100"
              onInput={linkState(this, 'form.password')}
              required
            />
            <Input
              label="Confirm password"
              type="password"
              value={password2}
              class="mb-3 w-100"
              onInput={linkState(this, 'form.password2')}
              required
            />
            {formSubmitted ? (
              <div class="text-center">
                <p>Welcome!</p>
                <p>You will be redirect to the payment page in {countdown}...</p>
              </div>
            ) : (
              <Button type="submit" class="float-right d-block">
                Sign Up
              </Button>
            )}
          </Form>
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  SignUp,
)



// WEBPACK FOOTER //
// ./pages/SignUp.js